// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"84edc568","622":"510588d8","732":"a78a2c96","744":"532a2462","977":"7123dddb"}[chunkId] + ".chunk.js";
};